export function addResizeObserver(element, cb) {
    if (element == null) {
        return;
    }
    if (typeof ResizeObserver === 'undefined') {
        return;
    }
    const resizeObserver = new ResizeObserver(cb);
    resizeObserver.observe(element);
    return () => {
        resizeObserver.disconnect();
    };
}
//# sourceMappingURL=addResizeObserver.js.map